import React from 'react';
import { Header, Table, Segment } from 'semantic-ui-react';
import { DestinatarioMatricola, Matricola } from '../models';
import parse from 'html-react-parser';

type MatricoleDestinatarioProps = {
    elemento: DestinatarioMatricola,
    active: string,
    onSelectMatricola: (matricola: Matricola) => void
}

export default class MatricoleDestinatario extends React.Component<MatricoleDestinatarioProps> {

    render() {
        const { elemento, onSelectMatricola, active } = this.props;
        const tertiary = active === elemento.idDestinatario;
        const secondary = !tertiary;
        const color = active === elemento.idDestinatario ? 'green' : undefined;

        return (
            <>
                <Segment attached='top' color={color} tertiary={tertiary} secondary={secondary}>
                    <Header>{elemento.destinatario}</Header>
                </Segment>
                <Table attached='bottom' selectable striped unstackable>
                    <Table.Body>
                        {elemento.matricole.map(matricola => {
                            return (
                                <Table.Row key={matricola.idSpecifica} onClick={() => onSelectMatricola(matricola)} style={{ cursor: 'pointer' }}>
                                    <Table.Cell width='2'>{matricola.numeroMacchina}</Table.Cell>
                                    <Table.Cell width='3'>{matricola.codice}</Table.Cell>
                                    <Table.Cell width='6'>{matricola.descrizione}</Table.Cell>
                                    <Table.Cell width='5'>{parse(matricola.ubicazione)}</Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
            </>
        );
    }
}